module.exports = __webpack_public_path__ + "static/media/prayer.243ca4c5.JPG";